module.exports = __webpack_public_path__ + "img/benefit-icon_unlock.256953ea.svg";